( function () {
	'use strict';

	/* ── Accordion open / close (single-open per block) ───────────────── */
	document.querySelectorAll( '.dgf-faq-item' ).forEach( function ( item ) {

		function toggleItem() {
			var isOpen  = item.classList.contains( 'open' );
			var wrapper = item.closest( '.accordion-block-wrap' );

			/* Close all siblings in the same accordion block first */
			if ( wrapper ) {
				wrapper.querySelectorAll( '.dgf-faq-item' ).forEach( function ( sibling ) {
					sibling.classList.remove( 'open' );
				} );
			}

			/* If item was closed → open it; if it was already open → leave closed */
			if ( ! isOpen ) {
				item.classList.add( 'open' );
			}
		}

		item.addEventListener( 'click', function ( e ) {
			/* Don't toggle when clicking inside the body (links etc.) */
			if ( e.target.closest( '.dgf-faq-body' ) ) { return; }
			toggleItem();
		} );

		item.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'Enter' || e.key === ' ' ) {
				e.preventDefault();
				toggleItem();
			}
		} );
	} );

	/* ── Category filter tabs ───────────────────────────────────────────── */
	document.querySelectorAll( '.dgf-filter-tabs' ).forEach( function ( tabsEl ) {

		var section = tabsEl.closest( '.accordion-block-wrap' );
		if ( ! section ) { return; }

		var items = Array.from( section.querySelectorAll( '.dgf-faq-item' ) );
		if ( ! items.length ) { return; }

		tabsEl.querySelectorAll( '[data-filter]' ).forEach( function ( tab ) {
			tab.addEventListener( 'click', function () {

				/* ── Activate clicked tab ── */
				tabsEl.querySelectorAll( '[data-filter]' ).forEach( function ( t ) {
					t.classList.remove( 'dgf-filter-active' );
				} );
				tab.classList.add( 'dgf-filter-active' );

				var filterVal = tab.dataset.filter || 'all';

				/* ── Show / hide items ── */
				items.forEach( function ( item ) {
					var cat = ( item.dataset.category || '' ).trim();

					// "all" tab or item has no category → always visible
					var visible = filterVal === 'all' || cat === '' || cat === filterVal;

					item.style.display = visible ? '' : 'none';

					// Collapse hidden items so they don't show a stale open state
					if ( ! visible ) {
						item.classList.remove( 'open' );
					}
				} );

				/* ── Scroll tabs into view on mobile (keep active tab visible) ── */
				tab.scrollIntoView( { behavior: 'smooth', block: 'nearest', inline: 'nearest' } );
			} );
		} );
	} );

} )();
